// Write your code here
import {Component} from 'react'
import './index.css'
import DestinationItem from '../DestinationItem'

class DestinationSearch extends Component {
  state = {input: ''}

  text = event => {
    this.setState({
      input: event.target.value,
    })
  }

  render() {
    const {input} = this.state
    const {destinationsList} = this.props
    const details = destinationsList.filter(each =>
      each.name.toLowerCase().includes(input.toLowerCase()),
    )
    return (
      <div className="bg">
        <h1>Destination Search</h1>
        <div>
          <input type="search" value={input} onChange={this.text} />
          <img
            src="https://assets.ccbp.in/frontend/react-js/destinations-search-icon-img.png"
            alt="search icon"
            className="search-icon"
          />
        </div>
        <ul className="unorder">
          {details.map(each => (
            <DestinationItem key={each.id} items={each} />
          ))}
        </ul>
      </div>
    )
  }
}
export default DestinationSearch
